module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "flex flex-cross-center"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.office.logo,
      "alt": "",
      "onerror": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.office.name))]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v(_vm._s(_vm.office.introduction))])])]), _vm._v(" "), _c('nav', {
    ref: "nav"
  }, [_c('ul', {
    staticClass: "flex-default"
  }, _vm._l((_vm.categoryList), function(li, index) {
    return _c('li', {
      class: {
        activeItem: _vm.activeIndex == index
      },
      on: {
        "click": function($event) {
          return _vm.routerPush(li, index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(li.name))])])
  }), 0)]), _vm._v(" "), (_vm.categoryId && _vm.categoryId !== 'desc') ? _c('section', [(_vm.list.length > 0) ? _c('ul', _vm._l((_vm.list), function(article) {
    return _c('li', {
      staticClass: "flex flex-main-justify",
      on: {
        "click": function($event) {
          return _vm.goPath(article)
        }
      }
    }, [_c('div', {
      staticClass: "info",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      class: ["title", "mult_line_ellipsis", article.images && article.images.length > 0 ? "min_height" : ""],
      domProps: {
        "innerHTML": _vm._s(article.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex date"
    }, [_c('div', {
      staticClass: "tag ellipsis",
      staticStyle: {
        "justify-content": "flex-start"
      }
    }, [(article.type != 'subject') ? _c('span', {
      staticClass: "tag-red",
      domProps: {
        "innerHTML": _vm._s(article.tags)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(article.source)
      }
    })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]), _vm._v(" "), (article.image) ? _c('div', {
      staticClass: "thumbnail",
      style: ({
        backgroundImage: 'url(' + article.image + ')'
      })
    }, [_c('i', {
      class: [article.type + '-icon']
    })]) : _vm._e()])
  }), 0) : _c('div', {
    staticClass: "desc no-desc"
  }, [_vm._v("该锦观号暂未发布内容")]), _vm._v(" "), (_vm.list.length > 0 && (_vm.data.page.next * 1 <= _vm.data.page.last * 1)) ? _c('footer', {
    on: {
      "click": _vm.getArticles
    }
  }, [_vm._v("加载更多")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e2789d3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-jinguan.vue
// module id = 859
// module chunks = 2